const PREFIX = process.env.REACT_APP_PREFIX_URI || 'http://localhost:5050';
const SELF_PREFIX = process.env.REACT_APP_PREFIX_SELF || 'http://localhost:3000';

export {
  PREFIX,
  SELF_PREFIX,
};
